"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.palettes = void 0;
var palettes = {
  euiPaletteColorBlind: {
    colors: ['#1EA593', '#2B70F7', '#CE0060', '#38007E', '#FCA5D3', '#F37020', '#E49E29', '#B0916F', '#7B000B', '#34130C']
  },
  euiPaletteForLightBackground: {
    colors: ['#0079A5', '#017F75', '#E5830E', '#A30000', '#DD0A73']
  },
  euiPaletteForDarkBackground: {
    colors: ['#4DA1C0', '#01B2A4', '#C06C4C', '#BF4D4D', '#F5258C']
  },
  euiPaletteForStatus: {
    colors: ['#58BA6D', '#6ECE67', '#A5E26A', '#D2E26A', '#EBDF61', '#EBD361', '#EBC461', '#D99D4C', '#D97E4C', '#D75949']
  }
};
exports.palettes = palettes;